<template>
    <span>Bienvenido <b>Credit Tools</b> - herramienta para apoyar en Créditos.</span>
</template>
<script>
  export default {
    name: 'notification-sample'
  }
</script>
<style>
</style>
